import { getViemClients, } from "@bracket/contractor-next";
import type { Config } from "@wagmi/core";
import {
	getContractWithABI,
	isAddress,
	isBlockHash,
	isWEIString,
	type ValidChainId,
	type BlockHash,
	type WEIString,
} from "@bracket/chainography";




export declare type UpdateVanityNavProps = {
	newNav: WEIString;
	vault: string;
	chainId?: ValidChainId;
	config?: Config;
};


/**
 * Update the NAV for a given vault, incrementing the epoch by one, and allowing adjusted values.
 * @param {Address} vault the vault address
 * @param {bigint|number|WEIString} newNav the value either in brkt, or a bigint 1e18 value.
* @returns {bigint} the numer of assets in its bigint format
 */
export const updateVanityNav = async ({
	newNav,
	vault,
	chainId = 1,
	config,
}: UpdateVanityNavProps): Promise<BlockHash> => {

	try {

		if(chainId !== 1)
			throw new Error("updateNav supports only chain 1");

		if(!isAddress(vault))
			throw new Error("invalid vault address");

		if(!isWEIString(newNav))
			throw new Error("newNav not a WEIString");

		const bNewNav = BigInt(newNav);
		const [vclient, wclient] = await getViemClients({ chainId, config, });
		const [_, abi] = getContractWithABI("BracketVault");

		const {
			request,
			result,
		} = await vclient.simulateContract({
			address: vault,
			abi,
			functionName: "updateVanityNav",
			args: [
				bNewNav,
			],
			account: wclient.account,
		});

		if(request) {
			const hash = await wclient.writeContract(request);
			if(isBlockHash(hash)) {
				return hash;
			}
			throw new Error("contract did not return a block hash");
		}
		throw new Error("contract simulated failed to simulate");
	} catch (err) {
		throw new Error(`@bracket/chainography/brktETH:updateVanityNav failed - ${err.message}`);
	}
};
